import { Pipe, PipeTransform } from '@angular/core';
import { User } from 'src/app/classes/user.class';

@Pipe({ name: 'pmName', standalone: true })
export class PmNamePipe implements PipeTransform {
    transform(pms: User[], id: number | null): string {
        if (id === null) return 'Alle projectleiders';
        return pms.find(pm => pm.id === id)?.name ?? 'Alle projectleiders';
    }
}
